import Blocklist from '../blocklist/Blocklist'
import Logger from '../helpers/Logger'
import WebModel from '../models/WebModel'
import * as Slots from './'
import { Slot } from './Slot'
import { SlotRenderer } from './SlotRenderer'
import SlotRepository from './SlotRepository'
import SlotCounter from './SlotCounter'
import { AuctionHouse } from '../auctionHouse/AuctionHouse'
import EventManager from '../eventManager/EventManager'

export default class SlotFactory {
  constructor(
    private model: WebModel,
    private blocklist: Blocklist,
    auctionHouse: AuctionHouse
  ) {
    EventManager.on(EventManager.events.slotRenderEnded, (event, slot) => {
      SlotRenderer.handleAdXAds(event, slot, auctionHouse)
      if (slot) {
        slot.displayAdUnitLabels(slot.adType)
      }
    })
  }

  new(slotModel: ISlotModel): Slot | undefined {
    try {
      if (this.blocklist.all || this.blocklist.contains(slotModel.adUnitId)) {
        return undefined
      }

      // @ts-ignore Sometimes we break the rules for the greater good
      const slot: Slot = new Slots[slotModel.type](slotModel, this.model)
      // Now that we have the final baseAdunitId and selector, check the blocklist
      const blocklisted = this.blocklist.isBlockListed(slot)
      if (blocklisted) {
        return undefined
      }

      if (SlotRenderer.render(slot)) {
        SlotCounter.increment(slotModel.type)
        Logger.debug(`Rendered slot ${slot.id}`)
        SlotRepository.add(slot)

        return slot
      }

      return undefined
    } catch (e) {
      Logger.debug(e)
      Logger.debug(`Slot ${slotModel.type} unable to instantiate!`)
    }
  }
}
